// This is the max-width of the editor container
// This won't be used when rendering emails, only in the editor UI
export const EditorContainerWidth = {
  web: 1400,
  desktop: 1200,
  mobile: 340,
  code: 800,
} as const;

// This is the max-width of the template content (the card etc)
// Will be used when rendering emails, and in the editor UI
export const EditorContentMaxWidth = 480;
